import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { deactivateCatalogItem } from "../../api/catalog-items";
import CatalogItem from "../../models/catalog-item";
import { RootState } from "../../store";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";

interface CatalogItemDeleteModalProps {
  show: boolean;
  catalogItem?: CatalogItem;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const CatalogItemDeleteModal: React.FC<CatalogItemDeleteModalProps> = ({
  show,
  catalogItem,
  onCancel,
  onSuccess,
}) => {
  const taxPayer = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer,
  );

  const [submitting, setSubmitting] = useState(false);

  const onDeactivateClick = async () => {
    if (catalogItem === undefined || catalogItem.id === undefined) {
      return;
    }

    setSubmitting(true);

    const status = await deactivateCatalogItem(catalogItem.id, taxPayer.id!);

    if (status.status !== SUCCESS) {
      errorAlert(status.detail ?? "Ha ocurrido un error!!");
    } else {
      onSuccess();
    }

    setSubmitting(false);
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="lg">
      <CModalHeader closeButton>
        <CModalTitle>Desactivar producto o servicio</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h4>
                ¿Desactivar «{catalogItem?.description}»? Deja de aparecer al
                cargar una factura.
              </h4>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              {/* Deactivated and never deleted: the issued documents still
                  point here, and closed periods still have to add up. */}
              <h6 className="mt-3 text-muted">
                No se borra: las facturas que ya lo usaron siguen apuntando acá
                y los informes de períodos cerrados lo siguen necesitando.
              </h6>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton
          disabled={submitting}
          onClick={onDeactivateClick}
          color="danger"
        >
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Desactivando..." : "Desactivar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default CatalogItemDeleteModal;
